import React from 'react';
import PropTypes from 'prop-types';

import { H2, Paragraph } from 'components/core/Typography';
import { Link } from 'components/core/Link';
import { Stars } from 'components/review/Stars';
import { FacilityImage } from 'components/facility/FacilityImage';
import { FacilityImageNotAvailable } from 'components/facility/ImageNotAvailable';
import { ImageBadge } from 'components/core/ImageBadge';

import priceTag from 'assets/images/icons/icon-price-tag.svg';

import './FacilityPromoCard.scss';

export default function FacilityPromoCard({
	name, url, image, distance, reviews, hasFmf
}) {
	return (
		<div className="facility-promo-card">
			<div className="image-and-badge">
				<Link
					href={url}
					hideBorder
					productClick
					className="facility-image-link"
				>
					{image ?
						<FacilityImage
							src={image}
							alt={name}
							size="medium"
						/> :
						<FacilityImageNotAvailable
							size="small"
						/>
					}
				</Link>
				{hasFmf &&
					<ImageBadge
						icon={priceTag}
						color="green"						
					/>
				}
			</div>
			<div className="facility-name">
				<Link
					href={url}
					hideBorder
				>
					<H2
						size="tiny"
						weight="standard"
						last
						className="facility-title"
					>
						{name}
					</H2>
				</Link>
			</div>
			<div>
				<Paragraph size="tiny" weight="light" color="gray" className="facility-distance">
					{distance} {distance !== 1 ? 'miles' : 'mile'} away
				</Paragraph>
				{reviews.count > 0 &&
					<Stars
						rating={reviews.average}
						size="small"
					/>
				}
			</div>
		</div>
	);
}

FacilityPromoCard.propTypes = {
	name: PropTypes.string,
	url: PropTypes.string,
	image: PropTypes.string,
	distance: PropTypes.number,
	reviews: PropTypes.object,
	hasFmf: PropTypes.bool
};
